import { FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '@src/utils/constants';
import { LoaderComponent } from '@component/LoaderComponent/LoaderComponent';
import { logger } from '@utils/logger';
import { toastError } from '@utils/helpers';
import { toastMessage } from '@utils/toastMessage';

export const AppleCallback: FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleAppleCallback = async () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');
      logger.log('has code ???', code);
      logger.log('searchParams--->', searchParams);

      if (code) {
        const targetEndpoint =
          state === 'attach'
            ? `${BASE_URL}/v1/users/payors/attach/apple`
            : `${BASE_URL}/auth/apple`;
        try {
          sessionStorage.setItem('sso_in_progress', 'true');
          await axios.post(targetEndpoint, { code }, { withCredentials: true });

          logger.log('Request successful to:', targetEndpoint);
          sessionStorage.removeItem('sso_in_progress');
          navigate('/');
        } catch (error: any) {
          sessionStorage.removeItem('sso_in_progress');
          logger.log('error', error);
          toastError(error, toastMessage.AUTH.noAccountLinkedToApple);
          navigate('/authorization/login');
        }
      } else {
        navigate('/authorization/login');
      }
    };

    handleAppleCallback();
  }, [searchParams, navigate]);

  return <LoaderComponent />;
};
